import { render, staticRenderFns } from "./innovationAwardsMobile.vue?vue&type=template&id=2131e024&scoped=true"
import script from "./innovationAwardsMobile.vue?vue&type=script&lang=js"
export * from "./innovationAwardsMobile.vue?vue&type=script&lang=js"
import style0 from "./innovationAwardsMobile.vue?vue&type=style&index=0&id=2131e024&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131e024",
  null
  
)

export default component.exports